
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Box, Text } from "rebass/styled-components";
import Layout from "../components/Layout";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";

function Terms(props) {
  const router = useRouter();
  const { t } = useTranslation("terms");

  return (
    <Layout
      title={t("title")}
      hideHeader={!!router.query.mobile_webview}
      hideFooter={!!router.query.mobile_webview}
    >
      <Box
        alignItems="center"
        mx={[2, 2, 2, "auto"]}
        sx={{
          maxWidth: "1000px",
          fontSize: 1,
          ".align-center": {
            textAlign: "center"
          },
          ".align-right": {
            textAlign: "right"
          },
          ".text-indent": {
            textIndent: "40px",
            marginLeft: "40px"
          },
          ".bordered": {
            border: "1px solid",
            padding: 1
          },
          ".underline": {
            textDecoration: "underline"
          },
          ul: {
            listStyle: "'-  ' !important"
          },
          "ul.circle": {
            listStyleType: "circle !important"
          },
          ".regular-font": {
            fontWeight: "normal"
          }
        }}
        pb={6}
      >
        <Text
          dangerouslySetInnerHTML={{
            __html: t("terms_html", {
              supportEmail: t("supportEmail"),
              supportPhone: t("supportPhone"),
              website: t("website"),
              websiteCapital: t("websiteCapital")
            })
          }}
        />
        <Text
          dangerouslySetInnerHTML={{
            __html: t("mangopay_html", {
              supportEmail: t("supportEmail"),
              supportPhone: t("supportPhone")
            })
          }}
        />
      </Box>
    </Layout>
  );
}

export default Terms;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/terms',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  